export const STORYTELLING_HEADER_META_KEYS = ["city", "founded", "type", "cuisine"];

export const STORYTELLING_HEADER_META_LAYOUT = {
  city: "left",
  founded: "left",
  type: "right",
  cuisine: "right",
};

const EMPTY_HEADER_FIELD = () => ({
  show: true,
  label: "",
  value: "",
});

export const DEFAULT_STORYTELLING_HEADER_META = {
  city: EMPTY_HEADER_FIELD(),
  founded: EMPTY_HEADER_FIELD(),
  type: EMPTY_HEADER_FIELD(),
  cuisine: EMPTY_HEADER_FIELD(),
};

export function getStorytellingHeaderMetaDefaults(_restaurant = {}, t) {
  return {
    city: {
      show: true,
      label: t("storytellingHeaderCityLabel"),
      value: "",
    },
    founded: {
      show: true,
      label: t("storytellingHeaderFoundedLabel"),
      value: "",
    },
    type: {
      show: true,
      label: t("storytellingHeaderTypeLabel"),
      value: "",
    },
    cuisine: {
      show: true,
      label: t("storytellingHeaderCuisineLabel"),
      value: "",
    },
  };
}

function normalizeHeaderField(raw, defaults) {
  const source = raw && typeof raw === "object" ? raw : {};
  return {
    show: source.show !== false,
    label:
      source.label != null && String(source.label).trim() !== ""
        ? String(source.label).trim()
        : defaults.label,
    value: source.value != null ? String(source.value).trim() : defaults.value,
  };
}

export function normalizeStorytellingHeaderMeta(raw, restaurant = {}, t) {
  const defaults = getStorytellingHeaderMetaDefaults(restaurant, t);
  const source = raw && typeof raw === "object" ? raw : {};

  return {
    city: normalizeHeaderField(source.city, defaults.city),
    founded: normalizeHeaderField(source.founded, defaults.founded),
    type: normalizeHeaderField(source.type, defaults.type),
    cuisine: normalizeHeaderField(source.cuisine, defaults.cuisine),
  };
}

export function serializeStorytellingHeaderMetaForSave(raw) {
  const source = raw && typeof raw === "object" ? raw : {};

  const serializeField = (key) => ({
    show: source[key]?.show !== false,
    label: String(source[key]?.label ?? "").trim(),
    value: String(source[key]?.value ?? "").trim(),
  });

  return {
    city: serializeField("city"),
    founded: serializeField("founded"),
    type: serializeField("type"),
    cuisine: serializeField("cuisine"),
  };
}

export function getVisibleStorytellingHeaderFields(headerMeta) {
  return STORYTELLING_HEADER_META_KEYS.flatMap((key) => {
    const field = headerMeta?.[key];
    if (!field?.show) return [];
    return [
      {
        key,
        side: STORYTELLING_HEADER_META_LAYOUT[key],
        label: field.label,
        value: field.value,
      },
    ];
  });
}
